import React from "react";

export const DOCK_FLOAT = "float";
export const DOCK_LEFT = "left";
export const DOCK_RIGHT = "right";

const DockingIcon = ({ direction, active = false, ...props }) => {
  const activeColor = active ? "#ffdb7a" : "white";
  const opacity = active ? "1" : "0.8";

  const getIcon = () => {
    switch (direction) {
      case DOCK_FLOAT:
        // Floating window icon (undocked)
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ cursor: "pointer" }}
            {...props}
          >
            <rect
              x="3"
              y="5"
              width="18"
              height="14"
              rx="1"
              stroke={activeColor}
              strokeWidth="2"
              opacity={opacity}
            />
            <line
              x1="3"
              y1="9"
              x2="21"
              y2="9"
              stroke={activeColor}
              strokeWidth="2"
              opacity={opacity}
            />
            <circle
              cx="6"
              cy="7"
              r="0.5"
              fill={activeColor}
              opacity={opacity}
            />
            <circle
              cx="8.5"
              cy="7"
              r="0.5"
              fill={activeColor}
              opacity={opacity}
            />
            <circle
              cx="11"
              cy="7"
              r="0.5"
              fill={activeColor}
              opacity={opacity}
            />
            {/* Dots indicating floating/moveable */}
            <circle
              cx="12"
              cy="13"
              r="0.5"
              fill={activeColor}
              opacity={opacity}
            />
            <circle
              cx="15"
              cy="13"
              r="0.5"
              fill={activeColor}
              opacity={opacity}
            />
            <circle
              cx="18"
              cy="13"
              r="0.5"
              fill={activeColor}
              opacity={opacity}
            />
            <circle
              cx="12"
              cy="16"
              r="0.5"
              fill={activeColor}
              opacity={opacity}
            />
            <circle
              cx="15"
              cy="16"
              r="0.5"
              fill={activeColor}
              opacity={opacity}
            />
            <circle
              cx="18"
              cy="16"
              r="0.5"
              fill={activeColor}
              opacity={opacity}
            />
          </svg>
        );

      case DOCK_LEFT:
        // Dock to left side icon
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ cursor: "pointer" }}
            {...props}
          >
            {/* Main window frame */}
            <rect
              x="3"
              y="4"
              width="18"
              height="16"
              rx="1"
              stroke={activeColor}
              strokeWidth="1.5"
              opacity={opacity * 0.5}
            />
            {/* Left docked panel */}
            <rect
              x="3"
              y="4"
              width="7"
              height="16"
              rx="1"
              fill={activeColor}
              opacity={opacity * 0.3}
            />
            <rect
              x="3"
              y="4"
              width="7"
              height="16"
              rx="1"
              stroke={activeColor}
              strokeWidth="2"
              opacity={opacity}
            />
            {/* Content lines in docked panel */}
            <line
              x1="5"
              y1="7"
              x2="8"
              y2="7"
              stroke={activeColor}
              strokeWidth="1"
              opacity={opacity * 0.7}
            />
            <line
              x1="5"
              y1="10"
              x2="8"
              y2="10"
              stroke={activeColor}
              strokeWidth="1"
              opacity={opacity * 0.7}
            />
            <line
              x1="5"
              y1="13"
              x2="8"
              y2="13"
              stroke={activeColor}
              strokeWidth="1"
              opacity={opacity * 0.7}
            />
          </svg>
        );

      case DOCK_RIGHT:
        // Dock to right side icon
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ cursor: "pointer" }}
            {...props}
          >
            {/* Main window frame */}
            <rect
              x="3"
              y="4"
              width="18"
              height="16"
              rx="1"
              stroke={activeColor}
              strokeWidth="1.5"
              opacity={opacity * 0.5}
            />
            {/* Right docked panel */}
            <rect
              x="14"
              y="4"
              width="7"
              height="16"
              rx="1"
              fill={activeColor}
              opacity={opacity * 0.3}
            />
            <rect
              x="14"
              y="4"
              width="7"
              height="16"
              rx="1"
              stroke={activeColor}
              strokeWidth="2"
              opacity={opacity}
            />
            {/* Content lines in docked panel */}
            <line
              x1="16"
              y1="7"
              x2="19"
              y2="7"
              stroke={activeColor}
              strokeWidth="1"
              opacity={opacity * 0.7}
            />
            <line
              x1="16"
              y1="10"
              x2="19"
              y2="10"
              stroke={activeColor}
              strokeWidth="1"
              opacity={opacity * 0.7}
            />
            <line
              x1="16"
              y1="13"
              x2="19"
              y2="13"
              stroke={activeColor}
              strokeWidth="1"
              opacity={opacity * 0.7}
            />
          </svg>
        );

      default:
        return null;
    }
  };

  return getIcon();
};

export default DockingIcon;
